// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__C8bf+","address":"Footer_address__mHfvM","mail":"Footer_mail__Eh9sT","tel":"Footer_tel__J94Ch","links":"Footer_links__Vp+8h"};